import React from 'react';
import { PropTypes } from 'prop-types';

// Components
import BasicSearch from './BasicSearch';
import ErrorHandler from '../../_molecules/ErrorHandler';
import SearchAuthCheck from '../../../../../algolia-search/js/components/sections/SearchAuthCheck';

// Helpers
import { PageSizeContext, SortByContext } from '../../../../../algolia-search/js/context/searchContext';
import { SearchTypeContext } from '../../../../../algolia-search/js/context/searchTypeContext';
import { urlToSearchState } from '../../../../../algolia-search/js/helpers/search';
import useSearchType from '../../../../../algolia-search/js/hooks/useSearchType';
import useSortBy from '../../../../../algolia-search/js/hooks/useSortBy';
import usePageSize from '../../../../../algolia-search/js/hooks/usePageSize';
import { ViewTypeContext } from '@context/viewTypeContext';
import useViewType from '@hooks/useViewType';

const { view } = urlToSearchState(window.location);

const Search = ({
    children,
    aroundLatLngViaIP = false,
    displayMap = false,
    defaultViewType = 'card',
    displayPagingToolbar = true,
    displaySearchBox,
    displaySearchOptions,
    filters,
    optionalFilters = [],
    hitsPerPage = 24,
    index,
    initialSearchState,
    maxWidth,
    updateSearchStateUrl = false,
    refinementComponent,
    AboveSearchBoxComponent,
}) => {
    const { pageSize, setPageSize } = usePageSize(hitsPerPage);
    const { sortBy, setSortBy, setSortByDefault } = useSortBy({ index });
    const { viewType, setViewType } = useViewType({ defaultView: view || defaultViewType });
    const { searchType, setSearchType } = useSearchType({ defaultSearchType: { index } });

    return (
        <ErrorHandler>
            <SearchTypeContext.Provider value={[searchType, setSearchType]}>
                <ViewTypeContext.Provider value={[viewType, setViewType]}>
                    <SortByContext.Provider value={[sortBy, setSortBy, setSortByDefault]}>
                        <PageSizeContext.Provider value={[pageSize, setPageSize]}>
                            <SearchAuthCheck>
                                <BasicSearch
                                    aroundLatLngViaIP={aroundLatLngViaIP}
                                    displayMap={displayMap}
                                    displayPagingToolbar={displayPagingToolbar}
                                    displaySearchBox={displaySearchBox}
                                    displaySearchOptions={displaySearchOptions}
                                    filters={filters}
                                    hitsPerPage={pageSize.hitsPerPage}
                                    index={index}
                                    initialSearchState={initialSearchState}
                                    maxWidth={maxWidth}
                                    optionalFilters={optionalFilters}
                                    updateSearchStateUrl={updateSearchStateUrl}
                                    RefinementComponent={refinementComponent}
                                    AboveSearchBoxComponent={AboveSearchBoxComponent}
                                >
                                    {children}
                                </BasicSearch>
                            </SearchAuthCheck>
                        </PageSizeContext.Provider>
                    </SortByContext.Provider>
                </ViewTypeContext.Provider>
            </SearchTypeContext.Provider>
        </ErrorHandler>
    );
};

Search.propTypes = {
    children: PropTypes.node.isRequired,
    aroundLatLngViaIP: PropTypes.bool,
    displayMap: PropTypes.bool,
    defaultViewType: PropTypes.string,
    displayPagingToolbar: PropTypes.bool,
    displaySearchBox: PropTypes.bool,
    displaySearchOptions: PropTypes.bool,
    filters: PropTypes.string,
    hitsPerPage: PropTypes.number,
    index: PropTypes.string.isRequired,
    initialSearchState: PropTypes.object,
    maxWidth: PropTypes.string,
    optionalFilters: PropTypes.array,
    updateSearchStateUrl: PropTypes.bool,
    refinementComponent: PropTypes.any,
    AboveSearchBoxComponent: PropTypes.func,
};

export default Search;
